import svgPaths from "../../imports/svg-aj18vyrf1e";

export function FigmaFeatures() {
  return (
    <section className="bg-[#f7f7f7] py-8 md:py-12">
      <div className="container mx-auto px-4 max-w-[1560px]">
        <h2 className="text-[#101828] text-[24px] md:text-[30px] font-bold leading-[30px] md:leading-[36px] text-center mb-2">
          ¿Por qué elegir nuestro seguro?
        </h2>
        <p className="text-[#4a5565] text-[14px] md:text-[16px] leading-[20px] md:leading-[24px] text-center mb-[24px] md:mb-[34px]">
          La protección más completa para tu patinete eléctrico
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 max-w-[1089px] mx-auto">
          {/* Ya disponible y sin esperas */}
          <div className="bg-white border border-[#e8e8e8] rounded-[12px] p-[18px] min-h-[156.5px]">
            <div className="bg-white border-2 border-[#190654] rounded-full w-[42px] h-[42px] flex items-center justify-center mb-[9px]">
              <svg className="w-[28px] h-[28px]" fill="none" viewBox="0 0 28 28">
                <path d="M14 18.6667H14.0117" stroke="#FF6900" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.33333" />
                <path d="M14 9.33333V14" stroke="#FF6900" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.33333" />
                <path d={svgPaths.p8f53000} stroke="#FF6900" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.33333" />
              </svg>
            </div>
            <h3 className="text-[#444] text-[18px] font-bold leading-[20px] text-left mb-[13px]">
              Ya disponible y sin esperas
            </h3>
            <p className="text-[#717171] text-[14px] leading-[16px]">
              Si tienes tu número de matricula, la contratación es al instante en pocos minutos
            </p>
          </div>

          {/* Cubre lo obligatorio */}
          <div className="bg-white border border-[#e8e8e8] rounded-[12px] p-[18px] min-h-[156.5px]">
            <div className="bg-white border-2 border-[#190654] rounded-full w-[42px] h-[42px] flex items-center justify-center mb-[9px]">
              <svg className="w-[28px] h-[28px]" fill="none" viewBox="0 0 28 28">
                <path d={svgPaths.p1b228440} stroke="#FF6900" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.33333" />
              </svg>
            </div>
            <h3 className="text-[#444] text-[18px] font-bold leading-[20px] text-left mb-[13px]">
              Cubre lo obligatorio
            </h3>
            <p className="text-[#717171] text-[14px] leading-[16px]">
              Con la tranquilidad de circular cumpliendo la nueva legislación en todos los aspectos
            </p>
          </div>

          {/* Sin sorpresas */}
          <div className="bg-white border border-[#e8e8e8] rounded-[12px] p-[18px] min-h-[156.5px]">
            <div className="bg-white border-2 border-[#190654] rounded-full w-[42px] h-[42px] flex items-center justify-center mb-[9px]">
              <svg className="w-[28px] h-[28px]" fill="none" viewBox="0 0 28 28">
                <path d={svgPaths.p3d881300} stroke="#FF6900" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.33333" />
                <path d={svgPaths.p8784800} stroke="#FF6900" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.33333" />
                <path d="M8.16667 24.5H19.8333" stroke="#FF6900" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.33333" />
                <path d="M14 3.5V24.5" stroke="#FF6900" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.33333" />
                <path d={svgPaths.p31531f10} stroke="#FF6900" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.33333" />
              </svg>
            </div>
            <h3 className="text-[#444] text-[18px] font-bold leading-[20px] text-left mb-[13px]">
              Sin sorpresas
            </h3>
            <p className="text-[#717171] text-[14px] leading-[16px]">
              Con coberturas de reclamación de daños, multas y asistencia jurídica.
            </p>
          </div>

          {/* Con aseguradora de primer nivel */}
          <div className="bg-white border border-[#e8e8e8] rounded-[12px] p-[18px] min-h-[156.5px]">
            <div className="bg-white border-2 border-[#190654] rounded-full w-[42px] h-[42px] flex items-center justify-center mb-[9px]">
              <svg className="w-[28px] h-[28px]" fill="none" viewBox="0 0 28 28">
                <path d={svgPaths.p3da6200} stroke="#FF6900" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.33333" />
                <path d={svgPaths.p394f8700} stroke="#FF6900" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.33333" />
                <path d={svgPaths.pb465bc0} stroke="#FF6900" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.33333" />
              </svg>
            </div>
            <h3 className="text-[#444] text-[18px] font-bold leading-[20px] text-left mb-[13px]">
              Con aseguradora de primer nivel
            </h3>
            <p className="text-[#717171] text-[14px] leading-[16px]">
              Gracias a <span className="font-bold text-red-600">Linea Directa</span> tendrás la garantía de un soporte y coberturas excelentes
            </p>
          </div>

          {/* Gestión fácil a través de APP */}
          <div className="bg-white border border-[#e8e8e8] rounded-[12px] p-[18px] min-h-[156.5px]">
            <div className="bg-white border-2 border-[#190654] rounded-full w-[42px] h-[42px] flex items-center justify-center mb-[9px]">
              <svg className="w-[28px] h-[28px]" fill="none" viewBox="0 0 28 28">
                <path d={svgPaths.p18eadc00} stroke="#FF6001" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.33333" />
                <path d="M14 21H14.0117" stroke="#FF6001" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.33333" />
              </svg>
            </div>
            <h3 className="text-[#444] text-[18px] font-bold leading-[20px] text-left mb-[13px]">
              Gestión fácil a través de APP
            </h3>
            <p className="text-[#717171] text-[14px] leading-[16px]">
              Para llevar siempre la documentación contigo y poder dar partes al instante.
            </p>
          </div>

          {/* Para la mayoría de patinetes */}
          <div className="bg-white border border-[#e8e8e8] rounded-[12px] p-[18px] min-h-[156.5px]">
            <div className="bg-white border-2 border-[#190654] rounded-full w-[42px] h-[42px] flex items-center justify-center mb-[9px]">
              <svg className="w-[28px] h-[28px]" fill="none" viewBox="0 0 24 24" stroke="#FF6900" strokeWidth="2">
                {/* Rueda trasera */}
                <circle cx="6" cy="20" r="2" />
                {/* Rueda delantera */}
                <circle cx="18" cy="20" r="2" />
                {/* Plataforma baja */}
                <line x1="8" y1="20" x2="16" y2="20" strokeLinecap="round" />
                {/* Tubo vertical desde plataforma hasta manillar */}
                <line x1="8" y1="20" x2="10" y2="6" strokeLinecap="round" />
                {/* Manillar horizontal */}
                <line x1="8" y1="6" x2="12" y2="6" strokeLinecap="round" />
              </svg>
            </div>
            <h3 className="text-[#444] text-[18px] font-bold leading-[20px] text-left mb-[13px]">
              Para la mayoría de patinetes
            </h3>
            <p className="text-[#717171] text-[14px] leading-[16px]">
              Ya sea tu patinete nuevo o usado, si está certificado podrás asegurarlo
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}